import React, { Component } from 'react';

class TermsOfService extends Component {

  render() {
    return (
      <div style={{ padding: '20px', color: 'white'}}>
        <h2>Epoch - 服务政策</h2>
        <p>
          在购买 Epoch 高级版之前，我们强烈建议您阅读以下的服务条款
          <br/>
          <br/>
          <b style={{ fontSize: 18 }}>订阅会员</b>
          <br/>
          <br/>
          我们使用应用内购的方式来管理我们的会员制度，目前我们提供月度会员和年度会员两种自动续费的会员，我们也提供了一次买断制的永久会员，您可以根据自己的需求选择。
          <br/>
          <br/>
          月度会员和年度会员会在周期结束前自动从您的 iTunes 账号中扣费，如果你想取消订阅，请在当前周期结束前 24 个小时关闭订阅。
          <br/>
          <br/>
          购买 Epoch 高级版的三种方式：
          <br/>
          <br/>
          <li>Epoch 高级版永久会员 (一次支付)</li>
          <li>Epoch 高级版月度会员 (每月自动支付, 您可以随时取消)</li>
          <li>Epoch 高级版年度会员 (每年自动支付, 您可以随时取消)</li>
          <br/>
          <br/>
          您可以在 <a href="https://apps.apple.com/account/subscriptions">App Store</a> 里管理您的订阅
          <br/>
          <br/>
          <b style={{ fontSize: 18 }}>Epoch 高级版功能</b>
          <br/>
          <br/>
          我们给吉他学习者提供了专业的功能：
          <br/>
          <br/>
          <li>自定义调音，指弹利器</li>
          <li>练琴数据分析，帮助您养成良好的练琴习惯</li>
          <li>设置目标和提醒</li>
          <li>调音器的自动模式，方便快捷</li>
          <li>音高检测功能，88 个钢琴音调音功能，帮助您训练绝对音感</li>
          <br/>
          <br/>
          <b style={{ fontSize: 18 }}>退款</b>
          <br/>
          <br/>
          很抱歉您需要退款服务, 请先<a href="mailto:panlei106@gmail.com">联系我们</a>，告诉我们您的看法和建议, 我们尊重您的选择. 退款服务由苹果客服团队负责, 您可以直接联系苹果的支持团队，更多信息请看 <a href="https://support.apple.com/en-us/HT204084">这里</a>
          <br/>
          <br/>
          <b style={{ fontSize: 18 }}>服务条款更新</b>
          <br/>
          <br/>
          我们会不定期更新服务条款，所以我们建议您周期性的阅读这个页面，如果有内容更新，我们会写到这个页面里，所有的改动将立即生效。
          <br/>
          <br/>
          <b style={{ fontSize: 18 }}>联系我们</b>
          <br/>
          <br/>
          如果对于服务条款有任何问题，请联系我们： <a href="mailto:panlei106@gmail.com">panlei106@gmail.com.</a>
          <br/>
          <br/>
          感谢您选择 Epoch!
          <br/>
          Epoch 团队
          <br/>
        </p>

        <h2 style={{ marginTop: 100 }}>Epoch - Terms of Service</h2>
        <p>
        Before purchasing Epoch Pro, you are strongly encouraged to read our Terms of Service as below
        <br/>
        <br/>
        <b style={{ fontSize: 18 }}>Subscription</b>
        <br/>
        <br/>
        We are using the subscription model to manage premium user membership, it is available as monthly & yearly subscription now, we also provide a Non-Consumable subscription for you to purchase Epoch Pro only once and never expire.
        <br/>
        <br/>
        The yearly & monthly subscription automatically renews and you account will be charged unless auto-renew is turned off at least 24 hours before the end of the current subscription period
        <br/>
        <br/>
        Epoch provide three options to unlock Pro features:
        <br/>
        <br/>
        <li>Epoch Pro Lifetime (One payment)</li>
        <li>Epoch Pro Monthly (Billing every month, you can cancel it at any time)</li>
        <li>Epoch Pro Yearly (Billing every year, you can cancel it at any time)</li>
        <br/>
        <br/>
        You are able to manage your subscriptions on the <a href="https://apps.apple.com/account/subscriptions">App Store</a> at any time
        <br/>
        <br/>
        <b style={{ fontSize: 18 }}>Epoch Pro Features</b>
        <br/>
        <br/>
        We provide some professional features for guitar learners:
        <br/>
        <br/>
        <li>Custom tunings</li>
        <li>Statistics for practicing</li>
        <li>Goal & Reminder</li>
        <li>Auto mode for tuner</li>
        <li>Pitch Detector for Perfect Pitch training</li>
        <br/>
        <br/>
        <b style={{ fontSize: 18 }}>Refund</b>
        <br/>
        <br/>
        We are sorry to hear that you want to refund, please <a href="mailto:panlei106@gmail.com">contact us</a> for your complains first, but we respect your choice. However, developers are not responsible for refunds, you are encouraged to contract Apple Support Team directly, some information could be found <a href="https://support.apple.com/en-us/HT204084">here</a>
        <br/>
        <br/>
        <b style={{ fontSize: 18 }}>Changes to This Terms of Service</b>
        <br/>
        <br/>
        We may update our Terms of Service from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting new Terms of Service on this page. These changes are effective immediately after they are posted on this page.
        <br/>
        <br/>
        <b style={{ fontSize: 18 }}>Contract Us</b>
        <br/>
        <br/>
        If you have any questions or suggestions about Terms of Service, do not hesitate to contact us at <a href="mailto:panlei106@gmail.com">panlei106@gmail.com.</a>
        <br/>
        <br/>
        Thanks for choosing Epoch!
        <br/>
        Epoch Team
        <br/>
        </p>
      </div>
    );
  }
}

export default TermsOfService